import React, { useState } from 'react';
import { approveReview, ensureReview } from './operations';

export default function ReviewsAdmin({ reviews, orders, customers, onRefresh }) {
  const [message, setMessage] = useState('');

  async function copyLink(order) {
    try {
      const review = await ensureReview(order);
      await navigator.clipboard.writeText(`${window.location.origin}/review?token=${review.token}`);
      setMessage('Customer review link copied. Send it to your customer.');
      await onRefresh();
    } catch (failure) {
      setMessage(failure.message);
    }
  }

  async function toggle(review) {
    try {
      await approveReview(review.id, !review.approved);
      await onRefresh();
    } catch (failure) {
      setMessage(failure.message);
    }
  }

  return <section className="crm-panel crm-feature">
    <div className="crm-panel-head"><div><h2>Customer reviews</h2><p>Copy a private review link for a customer, then approve submissions for the website.</p></div></div>
    {message && <p className="crm-notice" role="status">{message}</p>}
    <div className="crm-records">{orders.map((order) => {
      const review = reviews.find((item) => item.work_order_id === order.id);
      return <div className="crm-record" key={order.id}><div><strong>{customers.find((item) => item.id === order.customer_id)?.name} · {order.service}</strong>{review?.body ? <small>{'★'.repeat(review.rating)} “{review.body}” — {review.reviewer_name}</small> : <small>Awaiting review</small>}</div><button onClick={() => copyLink(order)}>Copy review link</button>{review?.body && <button onClick={() => toggle(review)}>{review.approved ? 'Remove approval' : 'Approve'}</button>}</div>;
    })}{reviews.filter((review) => !review.work_order_id && review.body).map((review) => <div className="crm-record" key={review.id}><div><strong>{review.reviewer_name} · Website review</strong><small>{'★'.repeat(review.rating)} “{review.body}”</small></div><button onClick={() => toggle(review)}>{review.approved ? 'Remove approval' : 'Approve'}</button></div>)}</div>
  </section>;
}